<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <!-- <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon> -->
            {{ $t('verify_otp') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="py-12 px-2 text-center">
          <img src="@/assets/images/svg/phone.svg" alt="phone" class="img-mail-verification">
          <h4 class="title font-weight-bold my-5">
            {{ $t('input_verification_code') }}
          </h4>
          <h5 class="subtitle-1 grey--text">
            {{ $t('verification_code_has_been_sent_to_phone') }}
          </h5>
          <h5 class="subtitle-1 grey--text font-weight-bold mb-4">
            {{ data_verification.data.new_phone }}
          </h5>
          <span class="primary--text mt-3 cursor-pointer" @click="changePhoneData()">
            {{ $t('change_phone') }}
          </span>
          <div class="d-flex justify-center mt-4">
            <CodeInput :loading="false" :fields="5" :auto-focus="true" :field-width="50" :field-height="50" class="input inputVerificationCode" @complete="onCompleteOtp" />
          </div>
          <div class="mt-12">
            <v-btn color="primary" :disabled="formattedTimeLeft === 'EXPIRED'" x-large block class="text-none" @click="verify()">
              {{ $t('confirm') }}
            </v-btn>
            <div class="mt-5 text-center">
              <v-progress-circular v-if="resendOtp" :width="3" color="primary" indeterminate />
              <a v-else-if="formattedTimeLeft === 'EXPIRED'" class="grey--text text-non-direction" @click="resendCode()">{{ $t('resend_code') }}</a>
              <div v-if="formattedTimeLeft !== 'EXPIRED' && formattedTimeLeft !== '00:00'" class="text-center font-weight-bold" v-html="formattedTimeLeft" />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog.changeDataPhone" max-width="300">
      <v-card>
        <ValidationObserver ref="observerChangePhone" v-slot="{ invalid, validated, passes, validate }">
          <v-form>
            <v-card-title class="headline">
              {{ $t('change_phone') }}
            </v-card-title>
            <v-card-text>
              <l-a-phone-number v-model="formChangeData.phone" :label="$t('fields.phone')" />
              <v-btn color="primary" x-large block class="text-none mt-5" @click="updatePhoneNumber()">
                {{ $t('next_2') }}
              </v-btn>
            </v-card-text>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="dataSuccess.show" multi-line top color="success" :timeout="3000">
      {{ dataSuccess.message }}
      <v-btn class="transparent" text fab x-small dark @click="closeDataSuccess()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  changePhone as changePhoneCustomer,
  updatePhone as updatePhoneCustomer
} from '@/api/customer'
import {
  ValidationObserver
} from 'vee-validate'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    LAPhoneNumber,
    ValidationObserver
  },
  data() {
    return {
      dataSuccess: {
        show: false,
        message: ''
      },
      data_verification: {},
      form: {
        old_phone: '',
        new_phone: '',
        otp_code: ''
      },
      formChangeData: {
        phone: ''
      },
      dialog: {
        changeDataPhone: false
      },
      resendOtp: false,
      timerInterval: null,
      distance: 0
    }
  },
  computed: {
    formattedTimeLeft() {
      let minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
      let result
      if (this.distance < 0) {
        result = 'EXPIRED'
      } else {
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = minutes + ':' + seconds
      }
      return result
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
    if (this.data_verification.data) {
      this.getExpiryTime(this.data_verification.data.detail.expiry_date_ext)
    }
  },
  methods: {
    closeDataSuccess() {
      this.dataSuccess.show = false
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.distance = countDownDate - now
        if (_this.distance < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    async verify() {
      this.form.old_phone = this.data_verification.data.phone
      this.form.new_phone = this.data_verification.data.new_phone
      try {
        const { data } = await updatePhoneCustomer(this.form)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = data.message
        this.$store.dispatch('save_token', data)
        this.$store.dispatch('remove_data_verification')
        this.$store.dispatch('remove_type_Verification')
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain

        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async resendCode(otp_type = 1) {
      this.resendOtp = true
      let obj = {}
      obj = {
        otp_type: otp_type,
        new_phone: this.data_verification.data.new_phone,
        old_phone: this.data_verification.data.phone,
        password: this.data_verification.data.password
      }
      try {
        const { data } = await changePhoneCustomer(obj)
        this.$store.state.loading_axios = false
        this.dataSuccess.show = true
        this.dataSuccess.message = data.message
        this.data_verification.data = data.data
        this.$store.dispatch('data_verification', this.data_verification)
        this.getExpiryTime(data.data.detail.expiry_date_ext)
      } catch (e) {
        console.log(e)
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
      this.resendOtp = false
    },
    goBack() {
      this.$router.go(-1)
    },
    onCompleteOtp(v) {
      this.form.otp_code = v
    },
    changePhoneData() {
      this.dialog.changeDataPhone = true
    },
    async updatePhoneNumber() {
      const isValid = await this.$refs.observerChangePhone.validate()
      if (isValid) {
        // try {
        //   const { data } = await changePhoneAuthCustomer(this.data_verification.value.id, this.formChangeData)
        //   this.$store.state.loading_axios = false
        //   this.dataSuccess.show = true
        //   this.dataSuccess.message = data.message
        //   this.data_verification.value.phone = data.data.phone
        //   this.form.phone = data.data.phone
        //   this.$store.dispatch('data_verification', this.data_verification)
        //   this.dialog.changeDataPhone = false
        //   this.formChangeData.phone = ''
        //   this.resendCode()
        // } catch (e) {
        //   this.$store.state.show_error = true
        //   this.$store.state.error_message = e.string
        //   this.$store.state.error_type = e.statusCode
        // }
      }
    }
  }
}
</script>
